import { Ref, ref } from "vue";
import { openMemberDialog } from "../memberDialog/member";

// 控制开关
const showMessageBox: Ref<boolean> = ref(false);
const messageType: Ref<string> = ref("");

const typeObj: any = {
  generationPPT: {
    title: "",
    content: "生成 ppt 功能仅对会员开放，是否购买会员？",
    confirmText: "购买会员",
    cancelText: "关闭",
    confirm: () => {
      openMemberDialog();
      showMessageBox.value = false;
    },
    cancel: () => {
      showMessageBox.value = false;
    },
  },
  downloadPPT: {
    title: "",
    content: "导出 ppt 功能仅对会员开放，是否购买会员？",
    confirmText: "购买会员",
    cancelText: "关闭",
    confirm: () => {
      openMemberDialog();
      showMessageBox.value = false;
    },
    cancel: () => {
      showMessageBox.value = false;
    },
  },
  changeOutline: {
    title: "",
    content: "换个大纲功能仅对会员开放，是否购买会员？",
    confirmText: "购买会员",
    cancelText: "关闭",
    confirm: () => {
      openMemberDialog();
      showMessageBox.value = false;
    },
    cancel: () => {
      showMessageBox.value = false;
    },
  },
};

// 控制显示的内容
const messageBoxContent = ref({
  title: "",
  content: "",
  content_type: "text",
  confirm: () => {},
  cancel: () => {},
  confirmText: "确定",
  cancelText: "取消",
});

const showMessageBoxByType = (type: string) => {
  messageType.value = type;
  messageBoxContent.value = {
    title: typeObj[type].title,
    content: typeObj[type].content,
    content_type: "text",
    confirm: () => {
      typeObj[type].confirm();
    },
    cancel: () => {
      typeObj[type].cancel();
    },
    confirmText: typeObj[type].confirmText,
    cancelText: typeObj[type].cancelText,
  };
  showMessageBox.value = true;
};

export { showMessageBox, messageType, messageBoxContent, showMessageBoxByType };
